import { render } from "./founder-talent-page.vue?vue&type=template&id=175eecf6&ts=true"
import script from "./founder-talent-page.vue?vue&type=script&lang=ts"
export * from "./founder-talent-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__